import React, { ReactElement } from 'react';
import { Header } from 'elmo-elements';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import ContentManagerBaseRoutes, {
  ContentManagerParamTypes,
  ContentManagerTabs,
} from '../ContentManagerRoutes';

export interface ContentManagerHeaderProps {
  backButton?: {
    title: string;
    onClick: () => void;
  };
}
const ContentManagerHeader = ({
  backButton,
}: ContentManagerHeaderProps): ReactElement => {
  const history = useHistory();
  const { tabSelected } = useParams<ContentManagerParamTypes>();

  const commonTabLinks = [
    {
      label: 'Categories',
      onClick: () => {
        history.push(
          generatePath(ContentManagerBaseRoutes.path, {
            tabSelected: ContentManagerTabs.Categories,
          }),
        );
      },
      active: tabSelected === ContentManagerTabs.Categories,
    },
  ];

  return (
    <Header
      title="Content Manager"
      tabs={commonTabLinks}
      backButton={backButton}
    />
  );
};
export default ContentManagerHeader;
